<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.001 18.001">
  <path
    fill="#808080"
    d="M9 9.001 8.75.251a.25.25 0 1 1 .5 0L9 9.001Zm0 0 .25 8.75a.25.25 0 0 1-.5 0L9 9.001Zm0 0 8.75-.25a.25.25 0 1 1 0 .5L9 9.001Zm0 0-8.75.25a.25.25 0 0 1 0-.5l8.75.25Zm0 0L2.813 2.46a.25.25 0 0 0-.418.112.252.252 0 0 0 .064.242L9 9.001Zm0 0 6.541 6.187a.25.25 0 0 1-.112.418.25.25 0 0 1-.242-.064L9 9.001Zm0 0 6.187-6.541a.25.25 0 1 1 .354.354L9 9.001Zm0 0-6.541 6.187a.25.25 0 0 0 .354.354L9 9.001Z"
    data-player="true"
  />
</svg>
